function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgSearch = function SvgSearch(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M19.85 19.25 16.1 15.5M5.35 11a6.25 6.25 0 1 1 12.5 0 6.25 6.25 0 0 1-12.5 0Z",
    stroke: props.color,
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }));
};
export { SvgSearch as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjUiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNSAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZD0iTTE5Ljg1IDE5LjI1TDE2LjEgMTUuNU01LjM0OTk4IDExQzUuMzQ5OTggNy41NDgyMiA4LjE0ODIgNC43NSAxMS42IDQuNzVDMTUuMDUxOCA0Ljc1IDE3Ljg1IDcuNTQ4MjIgMTcuODUgMTFDMTcuODUgMTQuNDUxOCAxNS4wNTE4IDE3LjI1IDExLjYgMTcuMjVDOC4xNDgyIDE3LjI1IDUuMzQ5OTggMTQuNDUxOCA1LjM0OTk4IDExWiIgc3Ryb2tlPSIjMTExMDEyIiBzdHJva2Utd2lkdGg9IjEuNSIgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIiBzdHJva2UtbGluZWpvaW49InJvdW5kIi8+Cjwvc3ZnPgo=";